(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["CausalEditor"] = factory();
	else
		root["CausalEditor"] = factory();
})(Object(typeof self !== "undefined" ? self : this), () => {
return 